module.exports = __webpack_public_path__ + "img/logo-b2-dark-text.db32c4f2.svg";